module.exports = "https://img.xiyuyouxi.com/saas/img/de_icon6.01570da6.png";